import {Component, ChangeDetectionStrategy} from '@angular/core';
import {LoginTwoFAService} from './login-two-f-a.service';

@Component({
    templateUrl: './login-two-f-a-wrapper-page-component.component.html',
    providers: [
        /**
         * This service stores credentials while Log In process.
         * So provide it here in order to not publish the sensitive data to the root injector.
         */
        LoginTwoFAService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginTwoFAWrapperPageComponent {}
